import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";

function FlightTipsContent() {
    const title = useTranslation(`${singleModalTranslationKey}.flights.title`)
    const {
        title: subtitle,
        o1,
        o2,
        o3,
        o4,
        o5,
    } = useTranslation(`${singleModalTranslationKey}.flights.tips`)

    return (
        <TipsPerTransportType
            title={title}
            subtitle={subtitle}
            options={[
                {id: "flight-o1", option: o1},
                {id: "flight-o2", option: o2},
                {id: "flight-o3", option: o3},
                {id: "flight-o4", option: o4},
                {id: "flight-o5", option: o5},
            ]}
        />
    );
}

export default FlightTipsContent